import { gql } from '@/__generated__';
import { UseAuthorization_GetAuthorizationQuery } from '@/__generated__/graphql';

export type Authorization = UseAuthorization_GetAuthorizationQuery['authorization'];

const GET_AUTHORIZATION = gql(`#graphql
  query UseAuthorization_GetAuthorization {
    authorization {
      authorizationGeneral {
        updateDeviceAliasOtherOrganizations
        showOrganizationFilter
        updateUser
        simulateUser
        temporaryUser
        updateDeviceCollectionRelation
        updateAccountCollectionRelation
        createDevice
        updateDeviceHardwareConfiguration
        showStatusDeviceFilter
        viewSourceInfo
        createDevice
        updateDeviceUserAccess
        createDeviceUserAccess
        deleteDeviceUserAccess
        configMetricsView
        showAuditAdminUsers
        updateOrganizationPreferences
        updateOtherOrganizationsPreferences
        updateOtherUsersPreferences
        viewActivityLogs
        updateMultipleDevicesTags
        resendUserCredentials
        hardDeleteUser
      }
      authorizationDGA {
        updateInfoDGA
        retrySending
        retryMassiveSending
        setMaxFlow
        enableDevices
        updateNotifications
        updateTicket
      }
      authorizationSMA {
        updateInfoSMA
      }
      authorizationAlert {
        viewNotificationsSummary
        smsNotifications
      }
    }
  }
`);

export default GET_AUTHORIZATION;
